// frontend/shared-ui/src/components/PageHeader.jsx
import React from "react";
import Title from "./Title";

export default function PageHeader({
  title,
  subtitle,
  breadcrumbs = [],
  actions,
}) {
  return (
    <div className="fh-page-header">
      <div className="fh-page-header__left">
        {breadcrumbs.length > 0 && (
          <div className="fh-page-header__breadcrumbs">
            {breadcrumbs.map((crumb, i) => (
              <span key={i}>{crumb}</span>
            ))}
          </div>
        )}
        <Title level={2} subtitle={subtitle}>
          {title}
        </Title>
      </div>
      {actions && <div className="fh-page-header__actions">{actions}</div>}
    </div>
  );
}
